import SyncIcon from '@mui/icons-material/Sync';
import { FC } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';
import TreeQueues from './TreeQueues';
import TreeSemaphores from './TreeSemaphores';
import TreeSignals from './TreeSignals';
import TreeSyncEvents from './TreeSyncEvents';
import TreeUserEvents from './TreeUserEvents';

const TreeSynchronization: FC = () => {
  return (
    <StyledTreeItem itemId='synchronization' label={<TreeLabel icon={SyncIcon} label='Synchronization' />}>
      <TreeSignals />
      <TreeUserEvents />
      <TreeSyncEvents />
      <TreeSemaphores />
      <TreeQueues />
    </StyledTreeItem>
  );
};

export default TreeSynchronization;
